import type { liveSearchApiClient } from '@/scopes/search/search/infrastructure/live-search/api'
import * as React from 'react'
import { createLiveSearchApiClient } from '@/scopes/search/search/infrastructure/live-search/api/liveSearchApiClient'

interface HeaderDependencies {
  liveSearchApiClient: typeof liveSearchApiClient
}

const defaultDependencies: HeaderDependencies = {
  liveSearchApiClient: createLiveSearchApiClient({ contextItemId: '' }),
}

const HeaderDependenciesContext = React.createContext<HeaderDependencies>(defaultDependencies)

export function HeaderDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: HeaderDependencies }>) {
  return <HeaderDependenciesContext value={dependencies}>{children}</HeaderDependenciesContext>
}

export function useHeaderDependencies() {
  return React.use(HeaderDependenciesContext)
}
